import { useEffect, useState } from 'react';
import { RoundedDialog, StandardDialogActions } from '../../../Global/Components';
import { DialogContent, Typography, DialogTitle, Grid, TextField, Collapse } from '@mui/material';
import { ListItemAvatar, ListItemText, InputAdornment } from '@mui/material';
import { List, ListItem, ListItemIcon, Avatar, FormControlLabel, Switch } from '@mui/material';
import UserManager from '../../../Global/UserManager';
import StateManager from '../../../Global/StateManager';
import axios from 'axios';
import { green, grey } from '@mui/material/colors';
import { SearchRounded, CheckCircleRounded, CheckCircleOutlineRounded } from '@mui/icons-material';

const NewGroupDialog = ({ open, onClose, onResult, initial }) => {
  const [name, setName] = useState('');
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [pattern, setPattern] = useState('');
  const [saving, setSaving] = useState(false);
  const [withTimeout, setWithtimeout] = useState(false);
  const [userTimeout, setUserTimeout] = useState(2);

  useEffect(() => {
    UserManager.getUserList(true)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (!open) return;
    setName('');
    setSelectedUsers(initial || []);
    setWithtimeout(false);
    setUserTimeout(2);
  }, [open, initial]);

  function addDeleteUser(id) {
    let index = selectedUsers.indexOf(id);
    if (index > -1) {
      setSelectedUsers(selectedUsers.filter((x) => x !== id));
    } else {
      setSelectedUsers([...selectedUsers, id]);
    }
  }
  function done() {
    setSaving(true);
    const body = {
      name,
      users: selectedUsers,
      timeout: withTimeout ? userTimeout : null,
    };
    axios
      .post('/admin/management/addGroup', body)
      .then((res) => {
        setSaving(false);
        StateManager.setSuccessAlert('Group has been added');
        onResult(res.data);
        onClose();
        setName('');
        setSelectedUsers([]);
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
        setSaving(false);
      });
  }

  return (
    <RoundedDialog maxWidth="xs" fullWidth open={open} onClose={() => onClose(null)}>
      <DialogTitle>New Group</DialogTitle>
      <DialogContent>
        <Grid container sx={{ padding: '8px 0' }}>
          <TextField
            label="Group name"
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
            variant="outlined"
            inputProps={{ maxLength: 64 }}
          />
        </Grid>
        <Grid container item style={{ padding: '8px 0' }}>
          <FormControlLabel
            label="Log users in this group out after period of inactivity"
            onChange={(e) => setWithtimeout(e.target.checked)}
            control={<Switch checked={withTimeout} color="primary" />}
          />
          <Collapse in={withTimeout} style={{ width: '100%' }}>
            <Grid container alignItems="flex-end">
              <Typography sx={{ fontWeight: 500 }}>Set timeout:</Typography>
              <TextField
                sx={{ width: 150, margin: '5px 8px' }}
                value={userTimeout}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value < 2) return;
                  setUserTimeout(value);
                }}
                label="Timeout"
                type="number"
              />
              <Typography sx={{ fontWeight: 500 }}>minutes</Typography>
            </Grid>
          </Collapse>
        </Grid>

        <Grid container sx={{ padding: '8px 0' }}>
          <TextField
            placeholder="Search people"
            fullWidth
            value={pattern}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchRounded sx={{ color: grey[300] }} />
                </InputAdornment>
              ),
            }}
            onChange={(event) => setPattern(event.target.value.toLowerCase())}
            variant="standard"
          />
        </Grid>
        <Grid container>
          <List sx={{ minHeight: '25vh', overflow: 'auto', width: '100%', marginTop: 1 }}>
            {users
              .filter((user) => selectedUsers.includes(user._id))
              .filter((user) => user.fullName.toLowerCase().includes(pattern))
              .map((user, i) => (
                <ListItem
                  key={user._id}
                  button
                  style={{ borderRadius: 5 }}
                  onClick={() => {
                    addDeleteUser(user._id);
                    setPattern('');
                  }}
                >
                  <ListItemAvatar>
                    <Avatar src={user.avatar}>{user.avatarLetters}</Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={user.fullName} />
                  <ListItemIcon sx={{ marginLeft: 'auto' }}>
                    {selectedUsers.includes(user._id) ? (
                      <CheckCircleRounded fontSize="large" sx={{ color: green[500] }} />
                    ) : (
                      <CheckCircleOutlineRounded fontSize="large" sx={{ color: grey[300] }} />
                    )}
                  </ListItemIcon>
                </ListItem>
              ))}
          </List>
        </Grid>
      </DialogContent>
      <StandardDialogActions saving={saving} onClose={() => onClose(null)} doneButtonText="SAVE" onDone={done} />
    </RoundedDialog>
  );
};

export default NewGroupDialog;
